import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function OnToOff(props) {
  const { onClickAction, onClickCancel } = props;
  const { t } = useTranslation();

  useEffect(() => {
    sendTrackingInfo('Mis avisos', `Finalizar Aviso-Intencion`);
  }, []);

  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickCancel={onClickCancel}
      onClickOutside={onClickCancel}
      title={t('panel.modal.OnToOff.title')}
      message={t('panel.modal.OnToOff.text')}
      ctaCancel={t('panel.modal.cta.cancel')}
      ctaOk={t('panel.modal.cta.confirmFinishPosting')}
    />
  );
}

export { OnToOff };
